import FormSubmitSuccessPage from "@/pages/FormSubmitSuccessPage";

export default {
    path: '/form-submit-success',
    name: 'form-submit-success',
    component: FormSubmitSuccessPage
}